(function (aimi_image_library, $, app, undefined) {

  /**
   * Image Collections API.
   * @returns {{get: (function(): *)}} The Image Collections API object.
   */
  app.apis['image-collections'] = function () {
    return {
      'get': function () {
        return app.getRequest('/api/image/collection', {}, function () {
        }, function () {
        });
      }
    }
  }()

  app.apis['images'] = function () {
    return {
      'get': function (url) {
        return app.getRequest(url, {}, function () {
        }, function () {
        });
      }
    }
  }()

  app.apis['uploads'] = function () {
    return {
      'list': function (url) {
        return app.getRequest(url, {}, function () {
        }, function () {
        });
      }, upload: function (file) {
        let data = new FormData();
        data.append("file", file);
        return app.fileUploadRequest('/api/image/user', data, function (response) {
        }, function (response) {
        })
      },
      delete: function (id) {
        return app.deleteRequest(`/api/image/user/${id}`, {}, function () {
        }, function () {
        });
      }
    }
  }()

  app.apis['image-tags'] = function () {
    return {
      'fetch': function () {
        return app.getRequest(`/api/image/tag`, {}, function () {
        }, function () {
        });
      },

      save: function (requestData) {
        return app.postRequest(`/api/image/tag`, requestData, function () {
        }, function () {
        });
      },

      tagMultiple: async function (requestData) {
        let results = [];

        if (!app.isEmpty(requestData.addTags)) {
          requestData.addTags = Utils.uniqueTags(requestData.addTags);
        }
        if (!app.isEmpty(requestData.removeTags)) {
          requestData.removeTags = Utils.uniqueTags(requestData.removeTags);
        }

        if (!app.isEmpty(requestData.ids)) {
          console.log(requestData);
          requestData.ids = Utils.uniqueTags(requestData.ids);
          requestData.ids = requestData.ids.join(',');
          results = this.save(requestData);
        }
        return results;
      }
    }
  }();

  app.apis['user-tags'] = function () {
    return {
      'fetch': function () {
        return app.getRequest(`/api/user/tag`, {}, function () {
        }, function () {
        });
      },

      update: function (requestData) {
        return app.putRequest(`/api/image/tag/${requestData.id}`, requestData, function () {
        }, function () {
        });
      },

      save: function (requestData) {
        return app.postRequest(`/api/user/tag`, requestData, function () {
        }, function () {
        });
      },

      saveMultiple: async function (requestData) {
        let results = [];
        const tags = Utils.uniqueTags(requestData.tag);
        const batchPromises = tags.map(tag => this.save({'tag': tag}));
        results = results.concat(await Promise.all(batchPromises));
        return results;
      },


      delete: function (id) {
        return app.deleteRequest(`/api/image/tag/${id}`, {}, function () {
        }, function () {
        });
      }
    }
  }();

}(window.aimi_image_library = window.aimi_image_library || {}, jQuery, PreBuilt));
